import {Component, OnInit} from '@angular/core';
import {StorageService} from '../../services/storage.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router} from '@angular/router';
import {PermissoesService} from '../../services/permissoes.service';
import {ToastrService} from 'ngx-toastr';
import {UsuarioBc} from '../../model/usuario-bc';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: "app-download-csv",
  templateUrl: "./download-csv.component.html",
  styleUrls: ["./download-csv.component.scss"],
})
export class DownloadCsvComponent implements OnInit {
  usuarioLogado: UsuarioBc;
  cpfLogado: any;
  config: any;
  showModalAdd = false;
  showModalValidaCsv = false;
  currentPage = 1;
  totalPages = 1;
  range = 5;
  indexRange = 5;
  indexLimit = 0;
  listSolicitacoes: any[];
  paginacaoList = ["5", "10", "20", "30", "40", "50"];

  constructor(
    private storage: StorageService,
    private permissoesService: PermissoesService,
    private loading: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private authService: AuthService
  ) {
    this.config = JSON.parse(this.storage.getCurrentApp());
  }

  async ngOnInit() {
    await this.carregarDados();
  }

  private async carregarDados() {
    console.log('tentando carregar os dados - Download CSV');
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.usuarioLogado = this.authService.getUsuarioLogado();
    this.cpfLogado = this.usuarioLogado.cpf.trim().replace(/\D/gi, "");
    await this.loadData();
  }

  async loadData() {
    this.loading.show();
    this.listSolicitacoes = [];
    const result = await this.permissoesService.getSolicitacao().toPromise();
    this.listSolicitacoes = result.content;
    this.indexLimit = result.totalElements;
    this.totalPages = result.totalPages;
    this.loading.hide();
  }

  async onRangeChange(newRange: number) {
    this.range = newRange;
    if (this.range * this.currentPage <= this.indexLimit) {
      this.indexRange = this.range * this.currentPage;
    } else {
      this.indexRange = this.indexLimit;
    }
    await this.loadData();
  }

  async avancaPagina() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      if (this.range * this.currentPage <= this.indexLimit) {
        this.indexRange = this.range * this.currentPage;
      } else {
        this.indexRange = this.indexLimit;
      }
      await this.loadData();
    }
  }

  async voltaPagina() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.indexRange = this.range * this.currentPage;
      await this.loadData();
    }
  }

  async filter(searchQuery = false) {
    // this.loading.show();
    // const result: any = await this.solicitacoesService.getEstabFilhos(this.solicitacao.nuSolicitacao, this.solicitacao.nuAno, this.currentPage - 1, this.range, searchQuery);
    // this.estabFilhosFiltered = result.content;
    // this.solicitacao.estabelecimentosFilhos = this.estabFilhosFiltered;
    // this.indexLimit = result.totalElements;
    // this.totalPages = result.totalPages;
    // this.loading.hide();
  }

  async openManage(item) {
    await this.router.navigateByUrl(
      `/cpf-liberado-csv/${
        item.nomeMunicipioGeracaoArq
          ? item.ufGeracaoArq + "-" + item.nomeMunicipioGeracaoArq
          : item.ufGeracaoArq
      }/${item.id}`
    );
  }

  async openFiles(item) {
    await this.router.navigateByUrl(
      `/arquivo-csv/${item.idPortfolio}/${item.permissao}`
    );
  }

  async delete(item) {
    this.loading.show();
    try {
      await this.permissoesService.deleteSolicitacao(item.id);
      await this.loadData();
      this.loading.hide();
    } catch (e) {
      console.log(e);
      this.loading.hide();
    }
  }

  toogleModalAdd() {
    this.showModalAdd = !this.showModalAdd;
  }

  downloadManual() {
    const link = document.createElement("a");
    link.setAttribute("type", "hidden");
    link.href = "../../../assets/docs/manual-de-apoio.pdf";
    link.download = "manual-de-apoio.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  toogleModalValidaCsv() {
    this.showModalValidaCsv = !this.showModalValidaCsv;
  }

  async fecharModal(info) {
    if (info) {
      console.log("---------------> entrou", info);
      this.loading.show();
      try {
        await this.permissoesService.postSolicitacao(info);

        if (this.showModalAdd != false) {
          this.toogleModalAdd();
        }
        if (this.showModalValidaCsv != false) {
          this.toogleModalValidaCsv();
        }

        await this.loadData();
        this.loading.hide();
      } catch (e) {
        console.log(e);
        this.toast.error(
          "Atenção! Ocorreu um erro ao tentar salvar a Solicitação."
        );
        this.loading.hide();
      }
    } else {
      if (this.showModalAdd != false) {
        this.toogleModalAdd();
      }
      if (this.showModalValidaCsv != false) {
        this.toogleModalValidaCsv();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/download-csv/download-csv.component.ts